import { gray2, gray5, gray6, mainColor, white } from "assets/styleUtils";
import { FontText } from "components/FontText";
import Input from "components/Input/Input";
import useUser from "hooks/useUser";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useRoutes } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useRecoilValue } from "recoil";
import { signOnState } from "recoil/atoms";
import { post } from "utils/ApiUtil";

interface IParams {
  id: string;
  token: string;
  type: string;
}

export default function SignOnPage() {
  const signOnData = useRecoilValue(signOnState);
  const { login } = useUser();

  const nicknameRef = useRef(null);
  const recommenderRef = useRef(null);
  const cafeNicknameRef = useRef(null);

  const [nickname, setNickname] = useState("");
  const [cafeNickname, setCafeNickname] = useState("");
  const [isDream, setIsDream] = useState(false);
  const [recommender, setRecommender] = useState<string>("");
  const navigate = useNavigate();

  async function nickCheck() {
    if (recommender && nickname === recommender) {
      toast.error("본인을 추천할 수 없습니다.");
    }
    try {
      const { message, success } = await post("/api/user/nicknamecheck", {
        nickname,
      });
      if (!!success) {
        signOn();
      }
    } catch (error: any) {
      toast.error(
        error?.message || "에러가 발생했습니다. 관리자에게 문의해주세요"
      );
    }
  }

  const signOn = async () => {
    try {
      if (!signOnData) {
        return;
      }

      const { message, success } = await post("/api/user/signup", {
        name: "",
        nickname,
        gender: "",
        phone_number: "",
        sns_type: signOnData.type,
        sns_id: signOnData.id,
        sns_token: signOnData.token,
        recommender,
        cafeNickname,
        cafegrade: isDream ? "드림" : "",
      });
      if (success) {
        if (!!signOnData.type && !!signOnData.id) {
          const { success: loginSuccess } = await login({
            sns_type: signOnData.type,
            sns_id: signOnData.id,
          });
          if (loginSuccess) {
            toast.success(message);
            navigate("/");
          }
        }
      } else {
        toast(message);
      }
    } catch (error: any) {
      toast.error(
        error?.message || "에러가 발생했습니다. 관리자에게 문의해주세요"
      );
    }
  };

  return (
    <div>
      <div
        style={{
          width: "100%",
          paddingTop: "80px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div style={{ display: "block" }}>
          <div
            style={{
              fontSize: "18px",
              marginBottom: "10px",
              marginLeft: "10px",
            }}
          >
            닉네임을 입력해주세요
          </div>
          <Input
            ref={nicknameRef}
            value={nickname}
            onChange={(e) => setNickname(e)}
            clear={
              (nickname.length > 0 || undefined) && (() => setNickname(""))
            }
            placeholder="닉네임 입력"
            bottomContents="모든 회원에게 보이는 닉네임이에요."
            limit={20}
            width={300}
            height={30}
            style={{
              border: "1px solid gray",
              paddingLeft: "8px",
              paddingTop: "8px",
              paddingRight: "10px",
              borderRadius: "5px",
            }}
          />
          <div>
            <div
              style={{
                fontSize: "18px",
                marginBottom: "10px",
                marginTop: "30px",
                marginLeft: "10px",
              }}
            >
              혹시 멕마웨를 추천해준 사람이 있나요?
            </div>
            <Input
              ref={recommenderRef}
              value={recommender}
              onChange={(e) => setRecommender(e)}
              clear={
                (recommender.length > 0 || undefined) &&
                (() => setRecommender(""))
              }
              placeholder="닉네임 입력"
              bottomContents="추천인 닉네임을 입력해주세요!"
              limit={20}
              width={300}
              height={30}
              style={{
                border: "1px solid gray",
                paddingLeft: "8px",
                paddingTop: "8px",
                paddingRight: "10px",
                borderRadius: "5px",
              }}
            />
          </div>
          <div>
            <div
              style={{
                fontSize: "18px",
                marginBottom: "10px",
                marginTop: "30px",
                marginLeft: "10px",
              }}
            >
              멕마웨 카페에 가입 하셨나요?
            </div>
            <Input
              ref={cafeNicknameRef}
              value={cafeNickname}
              onChange={(e) => setCafeNickname(e)}
              clear={
                (cafeNickname.length > 0 || undefined) &&
                (() => setCafeNickname(""))
              }
              placeholder="닉네임 입력"
              bottomContents="카페 닉네임을 입력해주세요!"
              limit={20}
              width={300}
              height={30}
              style={{
                border: "1px solid gray",
                paddingLeft: "8px",
                paddingTop: "8px",
                paddingRight: "10px",
                borderRadius: "5px",
              }}
            />
          </div>
          <div>
            <div
              style={{
                fontSize: "18px",
                marginBottom: "10px",
                marginTop: "30px",
                marginLeft: "10px",
              }}
            >
              멕마웨 카페 등급이 드림회원이신가요?
            </div>
            <div
              style={{
                marginTop: 24,
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  // ...w100,
                  borderRadius: 4,
                  borderColor: gray6,
                  borderWidth: 1,
                  marginBottom: 8,
                  paddingTop: 5,
                  paddingBottom: 5,
                }}
              >
                <div
                  onClick={() => setIsDream(true)}
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: 20,
                    marginLeft: 20,
                  }}
                >
                  <img
                    src={
                      isDream
                        ? "/images/checkCircle.png"
                        : "/images/uncheckCircle.png"
                    }
                  />
                  <div
                    style={{
                      marginLeft: 6,
                    }}
                  >
                    <FontText
                      color={isDream ? gray2 : gray5}
                      lineHeight={25}
                      size={14}
                    >
                      예
                    </FontText>
                  </div>
                </div>
              </div>
              <div
                style={{
                  borderRadius: 4,
                  borderColor: gray6,
                  borderWidth: 1,
                  marginBottom: 8,
                  paddingTop: 5,
                  paddingBottom: 5,
                }}
              >
                <div
                  onClick={() => setIsDream(false)}
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: 20,
                    marginLeft: 20,
                  }}
                >
                  <img
                    src={
                      !isDream
                        ? "/images/checkCircle.png"
                        : "/images/uncheckCircle.png"
                    }
                  />
                  <div
                    style={{
                      marginLeft: -2,
                    }}
                  >
                    <FontText
                      color={!isDream ? gray2 : gray5}
                      lineHeight={25}
                      size={14}
                    >
                      아니요
                    </FontText>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          position: "relative",
          top: 50,
        }}
      >
        <button
          disabled={nickname.length > 0 ? false : true}
          onClick={nickCheck}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: `48px`,
            backgroundColor: nickname.length > 0 ? mainColor : gray5,
            borderRadius: `4px`,
            margin: `24px`,
            width: "150px",
          }}
        >
          <FontText size={18} weight="500" color={white}>
            가입하기
          </FontText>
        </button>
      </div>
      <ToastContainer
        position="bottom-center"
        limit={1}
        closeButton={false}
        autoClose={800}
        theme="light"
      />
    </div>
  );
}
